(() => {
    let activeIndex = 0;
    let videoImages = qsa('.js-engagement-video-slider__video_image');
    const arrowLeft = qs('.js-engagement-video-slider__video_image_navigator_arrow--left');
    const arrowRight = qs('.js-engagement-video-slider__video_image_navigator_arrow--right');
    const videoImagesContainer = qs('.js-engagement-video-slider__video_image_container');
    const videoImagesPaginatorBullets = qsa('.js-engagement-video-slider__video_image_pagination_bullet');
    const videoImagesPaginatorBulletActive = 'engagement-video-slider__video_image_pagination_bullet--active';
    const mobile = window.matchMedia('(max-width: 989px)');

    function updateDesktopVideoImagesPaginator(isNext) {
        if (videoImagesPaginatorBullets.length > 1) {
            if (isNext) {
                activeIndex++;
            }
    
            if (!isNext) {
                activeIndex--;
            }

            if (activeIndex === videoImagesPaginatorBullets.length) {
                activeIndex = 0;
            } else if (activeIndex < 0) {
                activeIndex = videoImagesPaginatorBullets.length - 1;
            }

            videoImagesPaginatorBullets.forEach((el, index) => {
                if (el.classList.contains(videoImagesPaginatorBulletActive)) {
                    el.classList.remove(videoImagesPaginatorBulletActive);
                }

                if (index === activeIndex) {
                    el.classList.add(videoImagesPaginatorBulletActive);
                }
            });
        }
    }

    if (arrowLeft && arrowRight) {
        arrowLeft.addEventListener('click', () => {
            videoImages = qsa('.js-engagement-video-slider__video_image');

            if (videoImages.length > 0 && !mobile.matches) {
                let lastElement = videoImages[videoImages.length - 1];
                let firstElement = lastElement;
                lastElement.remove();
    
                videoImagesContainer.prepend(firstElement);
            }
            
            updateDesktopVideoImagesPaginator(false);
        });

        arrowRight.addEventListener('click', () => {
            videoImages = qsa('.js-engagement-video-slider__video_image');

            if (videoImages.length > 0 && !mobile.matches) {
                let firstElement = videoImages[0];
                let lastElement = firstElement;
                firstElement.remove();

                videoImagesContainer.append(lastElement);
            }

            
            updateDesktopVideoImagesPaginator(true);
        });
    }

    const slider = qs(`.js-engagement-video-slider__video_image_slider`);

    if(slider && mobile.matches) {
        new Swiper (`.js-engagement-video-slider__video_image_slider`, {
            threshold: 11, // to prevent the click twice
            slidesPerView: 1.5,
            loop: true,
            spaceBetween: 16,
            allowTouchMove: true,
            centeredSlides: true,
            navigation: {
                nextEl: `.js-engagement-video-slider__video_image_navigator_arrow--right`,
                prevEl: `.js-engagement-video-slider__video_image_navigator_arrow--left`,
                clickable: true
              },
            pagination: {
                el: `.js-engagement-video-slider__video_image_pagination`,
                type: 'bullets'
            }
        });
    }
})();